import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rerouting-transition" }
const _hoisted_2 = { class: "rerouting-transition__logo" }
const _hoisted_3 = { class: "rerouting-transition__content" }

import {useTranslation} from '@malt/vue3-use';
    import Shapes from '@/profile-creation-wizard/common/ui/Shapes.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ReroutingTransition',
  setup(__props) {

    const {msg} = useTranslation();
    const imageProps = {height: '60', width: '125', alt: 'malt logo', src: '//dam.malt.com/rebranding2020/malt-logo/malt-red'};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", _normalizeProps(_guardReactiveProps(imageProps)), null, 16)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.transition.rerouting.line.1')), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(msg)('profile.creation.wizard.strategy.transition.rerouting.line.2')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "rerouting-transition__content__spinner" }, [
        _createElementVNode("joy-spinner")
      ], -1))
    ]),
    _createVNode(Shapes, { "is-malt-strategy": false })
  ]))
}
}

})